import { useAuth0 } from "@auth0/auth0-react";
import { createFileRoute } from "@tanstack/react-router";

type SignupSearch = {
  redirect?: string;
};

export const Route = createFileRoute("/signup")({
  component: Signup,
  validateSearch: (search: Record<string, unknown>): SignupSearch => ({
    redirect: (search.redirect as string) || ""
  })
});

function Signup() {
  const { redirect } = Route.useSearch();
  const { loginWithRedirect } = useAuth0();
  loginWithRedirect({
    appState: redirect ? { returnTo: redirect } : undefined,
    authorizationParams: {
      redirect_uri: `${window.location.origin}`,
      screen_hint: "signup"
    }
  });
}
